// extracted by mini-css-extract-plugin
module.exports = {"container":"comment-plugin_container__sTipb","checkboxContainer":"comment-plugin_checkboxContainer__2t-Qi"};